import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { DisplayedMeeting } from '../types';

const all = ['meetings'] as const;

export const meetingKeys = {
  all,
  lists: () => [...all, 'list'] as const,
  list: (spaceId: string) => [...meetingKeys.lists(), spaceId] as const,
};

export function useGetMeetings(spaceId: string | undefined) {
  return useQuery({
    queryKey: meetingKeys.list(spaceId ?? ''),
    queryFn: async () => {
      if (!spaceId) return [];

      const { data, error } = await apiClient
        .from('council_meetings')
        .select(`*, documents!meeting_id(id, file_url)`)
        .eq('space_id', spaceId)
        .order('start_time', { ascending: false });

      if (error) throw error;

      // Flatten the linked report document onto the meeting.
      return (data ?? []).map(({ documents, ...meeting }) => {
        const report = documents?.[0];

        return {
          ...meeting,
          report_url: report?.file_url ?? null,
          report_document_id: report?.id ?? null,
        };
      }) as DisplayedMeeting[];
    },
    enabled: !!spaceId,
  });
}
